//jshint module : true
import actionTypes from './action-types';

const setPageMeta = meta => {
    return {
        type: actionTypes.SET_PAGE_META,
        payload: meta
    };
};

export default {
    setPageMeta
};
